<div class="company-features">
  <div class="company-features__intro">
    <h2 class="company-features__title">Features</h2>
    <p class="company-features__description">
      Turn a feature on or off for this company, for Way-billed and imported memberships. Locations
      can only be turned off, never on beyond the company. {{ propagationNote }}
    </p>
  </div>

  <div class="company-features__state" *ngIf="!companyId">Loading company…</div>
  <div class="company-features__state" *ngIf="companyId && loading">Loading features…</div>
  <div
    class="company-features__state company-features__state--error"
    *ngIf="companyId && !loading && errorMessage"
  >
    {{ errorMessage }}
    <button type="button" class="btn btn-outlined btn-small" (click)="load()">Retry</button>
  </div>
  <div
    class="company-features__state"
    *ngIf="companyId && !loading && !errorMessage && rows.length === 0"
  >
    No feature flags found.
  </div>

  <div
    class="company-features__table"
    role="table"
    aria-label="Features"
    *ngIf="!loading && !errorMessage && rows.length > 0"
  >
    <div class="company-features__head" role="row">
      <div class="company-features__heading" role="columnheader">Action</div>
      <div class="company-features__heading" role="columnheader">
        Way-billed
        <span class="company-features__caption">Billed by Way</span>
      </div>
      <div class="company-features__heading" role="columnheader">
        Imported
        <span class="company-features__caption">Billed by the vendor</span>
      </div>
      <div class="company-features__heading" role="columnheader">
        <span class="company-features__sr-only">Details</span>
      </div>
      <div class="company-features__heading" role="columnheader">
        Apply to locations
        <span class="company-features__caption">One or many locations</span>
      </div>
    </div>

    <div class="company-features__row" role="row" *ngFor="let row of rows; trackBy: trackRow">
      <div class="company-features__action" role="cell">
        <span class="company-features__name">{{ row.title }}</span>
        <div class="company-features__description-lines">
          <p class="company-features__muted" *ngFor="let line of row.descriptionLines">
            {{ line }}
          </p>
        </div>
        <span class="company-features__note" *ngIf="row.globalOffNote">{{
          row.globalOffNote
        }}</span>
      </div>
      <div
        class="company-features__cell company-features__cell--all"
        role="cell"
        aria-colspan="2"
        *ngIf="row.all; else bySource"
      >
        <span class="company-features__cell-label" aria-hidden="true">All memberships</span>
        <ng-container
          *ngTemplateOutlet="flagSwitch; context: { $implicit: row.all }"
        ></ng-container>
      </div>
      <ng-template #bySource>
        <div class="company-features__cell" role="cell">
          <span class="company-features__cell-label" aria-hidden="true">Way-billed</span>
          <ng-container *ngIf="row.way as toggle; else notUsed">
            <ng-container
              *ngTemplateOutlet="flagSwitch; context: { $implicit: toggle }"
            ></ng-container>
          </ng-container>
        </div>
        <div class="company-features__cell" role="cell">
          <span class="company-features__cell-label" aria-hidden="true">Imported</span>
          <ng-container *ngIf="row.imported as toggle; else notUsed">
            <ng-container
              *ngTemplateOutlet="flagSwitch; context: { $implicit: toggle }"
            ></ng-container>
          </ng-container>
        </div>
      </ng-template>
      <div class="company-features__cell company-features__cell--tip" role="cell">
        <app-info-tip [label]="row.title" [text]="row.tip"></app-info-tip>
      </div>
      <div class="company-features__cell company-features__cell--locations" role="cell">
        <app-checkbox-multi-dropdown
          class="company-features__picker"
          appearance="input"
          [options]="row.locationOptions"
          [selectedIds]="row.selectedLocationIds"
          [selectAllEmitsIds]="true"
          [allOptionLabel]="locationLabels.all"
          [placeholder]="locationLabels.none"
          [multipleSelectionText]="locationLabels.many"
          [disabled]="saving || row.locationsLocked"
          emptyMessage="No active locations"
          [ariaLabel]="row.title + ' locations'"
          (selectedIdsChange)="onLocationsChange(row, $event)"
        >
          <svg
            cmdTriggerIcon
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M8 14s4.5-4.1 4.5-7.5a4.5 4.5 0 1 0-9 0C3.5 9.9 8 14 8 14Z"
              stroke="currentColor"
              stroke-width="1.3"
              stroke-linejoin="round"
            />
            <circle cx="8" cy="6.5" r="1.6" stroke="currentColor" stroke-width="1.3" />
          </svg>
        </app-checkbox-multi-dropdown>
      </div>
    </div>
  </div>
</div>

<ng-template #flagSwitch let-toggle>
  <mat-slide-toggle
    class="company-features__switch"
    [checked]="toggle.enabled"
    [disabled]="saving || toggle.locked"
    (change)="onToggle($event, toggle)"
    [aria-label]="toggle.ariaLabel"
    >{{ toggle.label }}</mat-slide-toggle
  >
</ng-template>

<ng-template #notUsed>
  <span class="company-features__muted" aria-label="Not used">—</span>
</ng-template>
